var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@/common';
import Header from '@/common/header';
import SidePanel from '@/common/side-panel';
import { useQuery } from '@/hoc/hooks/useQuery';
import { BackIcon, DownArrow, RefreshIcon, UpArrow } from '@/icons';
import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
var columns = [
    { key: 'jobId', label: 'Job Id', mobilePriority: true },
    { key: 'jobName', label: 'Job Name', mobilePriority: true },
    { key: 'scheduledDateTime', label: 'Scheduled Time', mobilePriority: true },
    { key: 'startTime', label: 'Start time', mobilePriority: false },
    { key: 'endTime', label: 'End time', mobilePriority: false },
    { key: 'status', label: 'Status', mobilePriority: true },
    { key: 'duration', label: 'Duration', mobilePriority: true },
];
export default function ViewLogs() {
    var _this = this;
    var _a = useState(null), sortConfig = _a[0], setSortConfig = _a[1];
    var _b = useState(''), searchTerm = _b[0], setSearchTerm = _b[1];
    var _c = useState(true), sidePanelOpen = _c[0], setSidePanelOpen = _c[1];
    var _d = useState(false), isMobile = _d[0], setIsMobile = _d[1];
    var _e = useState([]), initialData = _e[0], setInitialData = _e[1];
    var navigate = useNavigate();
    var _f = useQuery('/cron/job_logs'), apiResponse = _f.data, refetch = _f.refetch;
    var getStatusColor = function (status) {
        switch (status) {
            case 'Success':
            case 'Completed':
                return 'bg-green-100 text-green-600';
            case 'Error Occurred':
                return 'bg-red-100 text-red-600';
            case 'In Progress':
            case 'Running':
                return 'bg-blue-100 text-blue-600';
            case 'Pending':
                return 'bg-yellow-100 text-yellow-600';
            default:
                return 'bg-gray-100 text-gray-600';
        }
    };
    var sortData = function (key, direction) {
        setSortConfig({ key: key, direction: direction });
    };
    var filteredAndSortedData = useMemo(function () {
        var filteredData = __spreadArray([], initialData, true);
        if (searchTerm) {
            var term_1 = searchTerm.toLowerCase();
            filteredData = filteredData.filter(function (item) {
                return Object.values(item).some(function (val) { return val.toString().toLowerCase().includes(term_1); });
            });
        }
        if (sortConfig) {
            filteredData.sort(function (a, b) {
                if (a[sortConfig.key] < b[sortConfig.key]) {
                    return sortConfig.direction === 'asc' ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                    return sortConfig.direction === 'asc' ? 1 : -1;
                }
                return 0;
            });
        }
        return filteredData;
    }, [initialData, searchTerm, sortConfig]);
    useEffect(function () {
        var checkIfMobile = function () {
            setIsMobile(window.innerWidth < 768);
            if (window.innerWidth < 768) {
                setSidePanelOpen(false);
            }
        };
        checkIfMobile();
        window.addEventListener('resize', checkIfMobile);
        return function () { return window.removeEventListener('resize', checkIfMobile); };
    }, []);
    useEffect(function () {
        var _a;
        if ((_a = apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.data) === null || _a === void 0 ? void 0 : _a.length) {
            setInitialData(apiResponse.data);
        }
    }, [apiResponse]);
    var handleRefresh = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            refetch();
            return [2 /*return*/];
        });
    }); };
    console.log('helllllo');
    function formatDate(isoString) {
        var date = new Date(isoString);
        var options = {
            year: 'numeric',
            month: 'long', // e.g., "May"
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true, // Change to false for 24-hour format
        };
        return date.toLocaleString(undefined, options);
    }
    function formatIsoDateToLocal(isoString) {
        var date = new Date(isoString);
        var pad = function (n) { return n.toString().padStart(2, '0'); };
        var day = pad(date.getDate());
        var month = pad(date.getMonth() + 1); // Months are zero-based
        var year = date.getFullYear();
        var hours = pad(date.getHours());
        var minutes = pad(date.getMinutes());
        return "".concat(day, "-").concat(month, "-").concat(year, " ").concat(hours, ":").concat(minutes);
    }
    return (_jsxs("div", { className: 'flex min-h-screen bg-gray-50', children: [_jsx(SidePanel, { open: !isMobile && sidePanelOpen, onMenuClick: isMobile ? undefined : function () { return setSidePanelOpen(function (prev) { return !prev; }); }, isMobile: isMobile }), _jsx("div", { className: "flex-1 transition-all duration-300", style: {
                    width: isMobile
                        ? 'calc(100% - 4rem)'
                        : sidePanelOpen
                            ? 'calc(100% - 16rem)'
                            : 'calc(100% - 4rem)',
                }, children: _jsxs("div", { className: 'p-2 md:p-2', children: [_jsx(Header, {}), _jsxs("div", { className: 'flex items-center mb-6', children: [_jsx("div", { onClick: function () { return navigate(-1); }, className: 'cursor-pointer flex items-center', children: _jsx(BackIcon, {}) }), _jsx("h1", { className: 'text-2xl font-semibold text-gray-800 ml-2', children: "Logs" }), _jsx("div", { className: 'flex flex-col sm:flex-row gap-3 ml-auto', children: _jsx(Button, { icon: _jsx(RefreshIcon, {}), label: 'Refresh', className: 'px-4 py-2 rounded-lg border border-red-500 text-white bg-red-600 hover:bg-red-700 transition font-medium text-md', onClick: handleRefresh }) })] }), _jsxs("div", { className: 'bg-white p-4 md:p-6 rounded-xl shadow min-h-screen overflow-x-auto', children: [_jsx("div", { className: 'flex flex-col md:flex-row md:justify-between md:items-center mb-6 gap-4', children: _jsx("h1", { className: 'text-2xl font-bold text-gray-800', children: "All Logs" }) }), _jsx("div", { className: 'hidden md:block overflow-x-auto rounded-lg', children: _jsxs("table", { className: 'min-w-full bg-white', children: [_jsx("thead", { className: 'bg-indigo-950', children: _jsx("tr", { children: columns.map(function (column) { return (_jsx("th", { className: 'px-4 py-3 font-medium text-left text-xs text-white whitespace-nowrap uppercase tracking-wider', children: _jsxs("div", { className: 'flex items-center justify-between', children: [_jsx("span", { children: column.label }), _jsxs("div", { className: 'flex flex-col ml-1 text-gray-500 leading-none', children: [_jsx("button", { onClick: function () { return sortData(column.key, 'asc'); }, className: 'p-0 h-3 hover:text-gray-700', children: _jsx(UpArrow, { className: 'w-2 h-2 text-white' }) }), _jsx("button", { onClick: function () { return sortData(column.key, 'desc'); }, className: 'p-0 h-3 hover:text-gray-700', children: _jsx(DownArrow, { className: 'w-2 h-2 text-white' }) })] })] }) }, column.key)); }) }) }), _jsx("tbody", { className: 'divide-y divide-gray-200 bg-gray-300', children: filteredAndSortedData.map(function (log, idx) { return (_jsxs("tr", { children: [_jsx("td", { className: 'px-6 py-4 whitespace-nowrap text-sm text-gray-700', children: log.jobId }), _jsx("td", { className: 'px-6 py-4 whitespace-nowrap text-sm text-gray-700', children: log.jobName }), _jsx("td", { className: 'px-6 py-4 whitespace-nowrap text-sm text-gray-700', children: formatDate(log.scheduledDateTime) }), _jsx("td", { className: 'px-6 py-4 whitespace-nowrap text-sm text-gray-700', children: formatIsoDateToLocal(log.startTime) }), _jsx("td", { className: 'px-6 py-4 whitespace-nowrap text-sm text-gray-700', children: formatIsoDateToLocal(log.endTime) }), _jsx("td", { children: _jsx("span", { className: "px-2 py-1 rounded-full whitespace-nowrap text-sm font-medium ml-2 ".concat(getStatusColor(log.status)), children: log.status }) }), _jsx("td", { className: 'px-6 py-4 whitespace-nowrap text-sm text-gray-700', children: log.duration })] }, idx)); }) })] }) }), _jsx("div", { className: 'md:hidden space-y-3', children: filteredAndSortedData.map(function (log, idx) { return (_jsx("div", { className: 'bg-white p-4 rounded-lg border border-gray-200', children: _jsxs("div", { className: 'grid grid-cols-2 gap-2', children: [_jsx("div", { className: 'font-medium text-sm text-gray-500', children: "Job ID:" }), _jsx("div", { className: 'text-sm', children: log === null || log === void 0 ? void 0 : log.jobId }), _jsx("div", { className: 'font-medium text-sm text-gray-500', children: "Job Name:" }), _jsx("div", { className: 'text-sm', children: log === null || log === void 0 ? void 0 : log.jobName }), _jsx("div", { className: 'font-medium text-sm text-gray-500', children: "Scheduled Time:" }), _jsx("div", { className: 'text-sm', children: log === null || log === void 0 ? void 0 : log.scheduledDateTime }), _jsx("div", { className: 'font-medium text-sm text-gray-500', children: "Status:" }), _jsx("div", { className: "text-sm ".concat(getStatusColor(log === null || log === void 0 ? void 0 : log.status)), children: log === null || log === void 0 ? void 0 : log.status }), _jsx("div", { className: 'font-medium text-sm text-gray-500', children: "Duration:" }), _jsx("div", { className: 'text-sm', children: log === null || log === void 0 ? void 0 : log.duration })] }) }, idx)); }) })] })] }) })] }));
}
